var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"green-text",on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('div',{staticClass:"d-flex"},[_vm._t("default")],2),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"green-text__arrow",class:_vm.arrowDown && 'green-text__arrow-down'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }